
















import PropertyFilters from "@/views/modules/messaging-inbox/filters/components/propertyFilters.vue";
import Search from "@/views/modules/messaging-inbox/filters/components/search.vue";
import Sorting from "@/views/modules/messaging-inbox/filters/components/sorting.vue";
import StatusFilters from "@/views/modules/messaging-inbox/filters/components/statusFilters.vue";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    components: {
        PropertyFilters,
        StatusFilters,
        Search,
        Sorting,
    },
});
